import { useEffect } from 'react';
import {
  useSharedValue,
  useAnimatedStyle,
  withSequence,
  withSpring,
  withTiming,
} from 'react-native-reanimated';

import { animation } from '../tokens';

export function useCorrectPulse(trigger: boolean) {
  const scale = useSharedValue(1);
  const glowOpacity = useSharedValue(0);

  useEffect(() => {
    if (trigger) {
      scale.value = withSequence(
        withSpring(1.05, animation.spring.bouncy),
        withSpring(1, animation.spring.gentle),
      );
      glowOpacity.value = withSequence(
        withTiming(0.3, { duration: animation.quick }),
        withTiming(0, { duration: animation.slow }),
      );
    }
  }, [trigger, scale, glowOpacity]);

  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{ scale: scale.value }],
  }));

  const glowStyle = useAnimatedStyle(() => ({
    opacity: glowOpacity.value,
  }));

  return { animatedStyle, glowStyle };
}
